
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic11 as ObiHydraulic11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-11.js';
 
 
 

 
 export const ObiHydraulic11 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-11',
   elementClass: ObiHydraulic11Element,
   events: {
     
   }
  });
 
 